import { t } from "../i18n";
import { Component, type ReactNode } from "react";
import { useProjectStore } from "../state/projectStore";
import { downloadJson } from "../lib/download";
import { projectFileName, toProjectFile } from "../storage";

/**
 * Hata kabuğu (README §4.9): tam ekran koyu zemin + 520 px pencere, ölümcül hata bandı (#F6DAD6 / #B42318), mono seçilebilir hata metni;
 * alt barda `Yeniden başlat` (birincil) ve açık proje varsa `Projeyi JSON indir` (veri kaybını önler).
 */
export class ErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
  override state = { error: null as Error | null };
  static getDerivedStateFromError(error: Error): { error: Error } { return { error }; }
  override componentDidCatch(error: Error): void { console.error(error); }
  override render(): ReactNode {
    if (this.state.error) {
      const project = useProjectStore.getState().project;
      return (
        <div className="fixed inset-0 z-50 grid place-items-center p-4 bg-[#101215] text-[12px]">
          <div role="alert" className="w-full max-w-[520px] bg-cad-panel border border-cad-strong shadow-[0_18px_40px_-14px_rgb(0_0_0/0.6)] flex flex-col">
            <div className="h-[26px] flex items-center px-2 text-[11px] font-semibold bg-cad-badbg text-[#B42318]">{t("Beklenmeyen hata:")}</div>
            <pre className="m-3 p-2 bg-white border border-cad-line font-mono text-[11px] text-cad-ink whitespace-pre-wrap break-words select-text max-h-[50vh] overflow-auto">{this.state.error.message}{this.state.error.stack ? `\n\n${this.state.error.stack}` : ""}</pre>
            <div className="flex items-center justify-end gap-2 p-2 bg-cad-sub border-t border-cad-line">
              {project ? <button type="button" className="cad-btn-box" onClick={() => downloadJson(projectFileName(project), toProjectFile(project))}>{t("Projeyi JSON indir")}</button> : null}
              <button type="button" className="cad-btn-primary" onClick={() => this.setState({ error: null })}>{t("Yeniden dene")}</button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
